import * as ngCore from '@angular/core'

import { Store } from '../store'

import * as evaluationStep from './evaluation-step'
import * as packagesStep from './packages-step'
import * as resourcesStep from './resources-step'

/**
 * Body of modal used to deploy Quiver resources
 */
@ngCore.Component({
  imports: [
    evaluationStep.Component,
    packagesStep.Component,
    resourcesStep.Component,
  ],
  selector: 'atn-quiver-deployment-modal-body',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link Store} */
  public readonly store = ngCore.inject(Store)
}
